/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserDetailsSaveRequest} from '../models/UserDetailsSaveRequest';

export interface UpdateUserDetails$Request {
    userId: number;
    userDetailsSaveRequest: UserDetailsSaveRequest;
}

export interface UpdateUserDetails$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateUserDetailsRequest = createAction<PayloadData<void, UpdateUserDetails$Request>>('UPDATE_USER_DETAILS__UPDATE_USER_DETAILS__REQUEST');
export const updateUserDetailsSuccess = createAction<PayloadData<number, UpdateUserDetails$Request>>('UPDATE_USER_DETAILS__UPDATE_USER_DETAILS__SUCCESS');
export const updateUserDetailsFailure = createAction<PayloadData<Error, UpdateUserDetails$Request, true>>('UPDATE_USER_DETAILS__UPDATE_USER_DETAILS__FAILURE');

export const updateUserDetailsActions = [
    updateUserDetailsRequest,
    updateUserDetailsSuccess,
    updateUserDetailsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserDetailsSaveRequest} meta.userDetailsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateUserDetails = (meta: UpdateUserDetails$Request, config?: UpdateUserDetails$Config) => {
    return {
        CALL_API: {
            types: updateUserDetailsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}`,
            TRANSPORT_REQUEST_BODY: meta.userDetailsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

